import React from 'react';
import {
  FileDownloadOutlined,
  LocalShippingOutlined,
  Inventory2Outlined,
  CheckBoxOutlined,
  AssignmentOutlined,
} from '@mui/icons-material';
import { Animation, Button } from '../../assets/global/globalStyles';
import { fetchInformations } from '../../store/informations';
import { getInformations } from '../../utils/httpRequest';
import { useDispatch, useSelector } from 'react-redux';
import { GraphicCards, Form } from './styles';
import SkeletonElement from '../../skeletons/SkeletonElement';
import useLocalStorage from '../../hooks/useLocalStorage';
import GraphicCard from '../../components/GraphicCard';
import MetaTitle from '../../components/MetaTitle';
import useDebounce from '../../hooks/useDebounce';
import Input from '../../components/Forms/Input';

const defaultSettings = {
  dateBegin: '',
  dateEnd: '',
};

export default function Home() {
  const dispatch = useDispatch();
  const [{ dateBegin, dateEnd }, setAppSettings] = useLocalStorage(
    'home_filter',
    defaultSettings,
  );
  const informations = useSelector((state) => state.informations.data);
  const formRef = React.useRef(null);
  const debouncedClick = useDebounce(() => {
    setAppSettings(defaultSettings);
    formRef.current.setData({
      dateBegin: '',
      dateEnd: '',
    });
    dispatch(fetchInformations(getInformations({})));
  }, 500);

  const handleSubit = ({ dateBegin = null, dateEnd = null }) => {
    dispatch(
      fetchInformations(
        getInformations({
          dateBegin: dateBegin === '' ? null : dateBegin,
          dateEnd: dateEnd === '' ? null : dateEnd,
        }),
      ),
    );
  };

  const orderType = {
    'Pedido recebido': () => (
      <CheckBoxOutlined
        style={{ width: '100px', height: '100px', color: '#434343' }}
      />
    ),
    'Pedido em separação': () => (
      <FileDownloadOutlined
        style={{ width: '100px', height: '100px', color: '#434343' }}
      />
    ),
    'Pedido em conferência': () => (
      <AssignmentOutlined
        style={{ width: '100px', height: '100px', color: '#434343' }}
      />
    ),
    'Pedido em trânsito': () => (
      <LocalShippingOutlined
        style={{ width: '100px', height: '100px', color: '#434343' }}
      />
    ),
    'Pedido entregue': () => (
      <Inventory2Outlined
        style={{ width: '100px', height: '100px', color: '#434343' }}
      />
    ),
  };

  React.useEffect(() => {
    dispatch(
      fetchInformations(
        getInformations({
          dateBegin: dateBegin === '' ? null : dateBegin,
          dateEnd: dateEnd === '' ? null : dateEnd,
        }),
      ),
    );
    // eslint-disable-next-line
  }, [dispatch]);

  return (
    <Animation>
      <MetaTitle title="Gráficos" />
      <Form
        onSubmit={handleSubit}
        defaultValue={{ dateBegin, dateEnd }}
        ref={formRef}
      >
        <Input
          onChange={({ target }) =>
            setAppSettings((settings) => ({
              ...settings,
              dateBegin: target.value,
            }))
          }
          label="Data inicial:"
          value={dateBegin}
          name="dateBegin"
          type="date"
        />
        <Input
          onChange={({ target }) =>
            setAppSettings((settings) => ({
              ...settings,
              dateEnd: target.value,
            }))
          }
          label="Data Final:"
          value={dateEnd}
          name="dateEnd"
          type="date"
        />
        <Button type="submit" typeName="success">
          Filtrar
        </Button>
        <Button type="button" onClick={debouncedClick} typeName="success">
          Limpar Filtro
        </Button>
      </Form>
      <GraphicCards>
        {informations?.map((info, i) => (
          <GraphicCard
            key={i}
            title={info.orderStatus}
            quantity={info.quantity}
            icon={orderType[info.orderStatus]}
          />
        ))}
        {!informations.length &&
          [...Array(8)].map((_, i) => (
            <SkeletonElement key={i} type="graphic-card" />
          ))}
      </GraphicCards>
    </Animation>
  );
}
